import { BaseDivider, sx } from '@lucan/base-ui'

export default function LineaSeparatrice(props) {
  const { ...rest } = props

  return <BaseDivider {...rest} {...sx(rest, { mt: 2, mb: 2 })} />
}
